import { Grid } from '@material-ui/core';
import { useQuoteField } from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import { FormRowGrid, GridRowProps } from 'Quoting/components/shared/GridRow';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import { GPLUCoverageCode } from '../../../PlanTemplates/GWL/gpluConstants';
import { getGPLURatingBlockPropertyPaths } from '../PropertyPaths';

export const RatingBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getGPLURatingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-d5617f29-7e0b-4dcd-a6fa-80638fdcf93c'},
      items: [
        {
          key: '291f5949-c0bc-4798-89be-f245d7c60495',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Rate Format"
              id={propertyPaths.rateFormatCd}
              value={getQuoteFieldValue(propertyPaths.rateFormatCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.rateFormatCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUBenefitCoverageRatingDetails.rateFormatCd"
              coverageCode={GPLUCoverageCode.CHILD_TERM_LIFE}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Rating" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
